import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import SortableItem from './SortableItem'; // Your draggable item component

// A droppable wrapper for each slot
const DroppableSlot = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div ref={setNodeRef} className={`drop-slot ${isOver ? 'hovered' : ''}`}>
      {children}
    </div>
  );
};

const SortableContainer = ({ id, items, emptySlots = false, slotCount = 0 }) => {
  const displayItems = emptySlots ? Array.from({ length: slotCount }, (_, index) => items[index] || null) : items;

  return (
    <div className="sortable-container">
      {displayItems?.map((item, index) => {
        const slotId = `${id}-slot-${index}`;
        return (
          <DroppableSlot key={slotId} id={slotId}>
            {item ? (
              <div className="col">
                <SortableItem id={item.id} title={item.title} />
              </div>
            ) : (
              <div className="col">Drop here</div>
            )}
          </DroppableSlot>
        );
      })}
    </div>
  );
};

export default SortableContainer;
